var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.displayDate,
            expression: "displayDate",
          },
        ],
        staticClass: "form-control",
        attrs: { disabled: _vm.disabled, type: "text" },
        domProps: { value: _vm.displayDate },
        on: {
          change: () => _vm.dateUpdated(),
          input: function ($event) {
            if ($event.target.composing) return
            _vm.displayDate = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-calendar" })]
      ),
      _vm._v(" "),
      _c("date-picker", {
        staticClass: "small_date",
        attrs: {
          valueType: "format",
          shortcuts: _vm.shortcuts,
          open: _vm.open,
          placeholder: "Выберите дату",
          "disabled-date": _vm.disabledDates,
        },
        on: {
          "update:open": function ($event) {
            _vm.open = $event
          },
          change: _vm.dateUpdated,
        },
        model: {
          value: _vm.date,
          callback: function ($$v) {
            _vm.date = $$v
          },
          expression: "date",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }